"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { dark } from "@clerk/themes";
import { StoreProvider } from "../providers/StoreProvider";
import { Toaster } from "react-hot-toast";

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ClerkProvider
      afterSignOutUrl="/"
      appearance={{
        baseTheme: dark,
        variables: {
          colorPrimary: "#8b5cf6", // violet-500
          colorBackground: "#0a0a0a",
          colorInputBackground: "#1a1a1a",
          colorInputText: "#ffffff",
          colorText: "#ffffff",
          colorTextSecondary: "#a1a1aa",
          borderRadius: "0.75rem",
        },
        elements: {
          formButtonPrimary:
            "bg-gradient-to-r from-violet-500 to-pink-500 hover:from-violet-600 hover:to-pink-600",
          card: "bg-[#0a0a0a] border border-white/10",
          headerTitle: "text-white",
          headerSubtitle: "text-white/60",
          socialButtonsBlockButton:
            "bg-white/5 border-white/10 hover:bg-white/10 text-white",
          socialButtonsBlockButtonText: "text-white",
          formFieldLabel: "text-white/80",
          formFieldInput:
            "bg-white/5 border-white/10 text-white placeholder:text-white/40",
          footerActionLink: "text-violet-400 hover:text-violet-300",
          identityPreviewText: "text-white",
          identityPreviewEditButton: "text-violet-400",
          userButtonPopoverCard: "bg-[#0a0a0a] border border-white/10",
          userButtonPopoverActionButton: "text-white hover:bg-white/10",
          userButtonPopoverActionButtonText: "text-white",
          userButtonPopoverFooter: "hidden",
        },
      }}
    >
      <StoreProvider>
        {children}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: {
              background: '#1e293b',
              color: '#fff',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </StoreProvider>
    </ClerkProvider>
  );
}
